<template>
  <slot />
</template>

<script setup>
import { useLegacyHost } from "#ce/apps/shared/composables/useLegacyHost";
import { toBoolean } from "#ce/utils/props";
import { props as researchArticlesProps } from "./props";

const props = defineProps(researchArticlesProps);

function loadResearchArticles() {
  return import("./legacy/research-articles");
}

function bootResearchArticles({ bootResearchArticles: boot }, { host }) {
  return boot({ endpoint: props.endpoint, expanded: toBoolean(props.expanded), anchorTab: props.anchorTab }, host);
}

useLegacyHost({ load: loadResearchArticles, boot: bootResearchArticles });
</script>

<style>
:host {
  display: contents;
}

slot {
  box-sizing: inherit;
}
</style>
